import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CLIENT_BUILD_TIME } from '../build-time';

interface VersionInfo {
  buildTime: number;
}

@Component({
  selector: 'app-about-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.css']
})
export class AboutDialogComponent implements OnInit {
  loading = true;
  // Compiled directly into this bundle at build time (see write-build-time.js, run by the
  // prebuild npm script) - no network call needed to know what this tab is running, so there's
  // nothing here that can go stale, race, or need any clever eager-fetch logic in a service
  // constructor (an earlier attempt at that broke login entirely - see the CLAUDE memory note
  // on this). If this bundle is old, this constant is old - that's the whole point: it can never
  // disagree with the code it's compiled into.
  readonly clientBuildTime: number = CLIENT_BUILD_TIME;
  serverBuildTime: number | null = null;
  readonly userAgent = navigator.userAgent;

  constructor(public dialogRef: MatDialogRef<AboutDialogComponent>, private http: HttpClient) {}

  ngOnInit() {
    // Cache-busted so this always reflects what's actually deployed right now, even if some
    // layer between the browser and the server (corporate proxy, ISP, the PC itself) is caching
    // more aggressively than the server's no-cache headers intend.
    this.http.get<VersionInfo>(`/charitycentral/checkversion?v=${Date.now()}`).subscribe({
      next: v => { this.serverBuildTime = v.buildTime; this.loading = false; },
      error: () => { this.serverBuildTime = 0; this.loading = false; }
    });
  }

  get isUpToDate(): boolean {
    return !!this.clientBuildTime && !!this.serverBuildTime &&
      this.clientBuildTime === this.serverBuildTime;
  }

  formatBuildTime(t: number | null): string {
    if (!t) return 'Unknown';
    return new Date(t).toLocaleString();
  }

  close() {
    this.dialogRef.close();
  }
}
